import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Styled_DropZoneFileUpload } from "./styles";
import uploadCloudIcon from "~/src/images/Upload_Cloud_Icon.png";
import { RotaButton } from "@teamrota/rota-design";

const DropZoneFileUpload = ({ setIsSizeOrFileTypeError, setFile }) => {
  const isFileTypeValid = fileType => {
    switch (fileType) {
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return true;
      default:
        return false;
    }
  };

  const onDrop = useCallback(acceptedFiles => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();

      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");

      reader.onload = e => {
        // takes the file signature to determine it's real type
        const arr = new Uint8Array(e.target.result).subarray(0, 4);
        const isZipFile =
          arr[0] === 0x50 &&
          arr[1] === 0x4b &&
          arr[2] === 0x03 &&
          arr[3] === 0x04;
        const isXlsxFile =
          isFileTypeValid(file.type) ||
          (!file.type && file.name.toLowerCase().endsWith(".xlsx"));

        // XLSX is a ZIP container; the following version bytes can vary.
        // 25MB
        if (!isXlsxFile || !isZipFile || file.size > 25000000) {
          setFile(null);
          setIsSizeOrFileTypeError(true);
          return;
        }
        setIsSizeOrFileTypeError(false);
        setFile(file);
      };
      reader.readAsArrayBuffer(file);
    });
  }, []);
  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true
  });

  return (
    <Styled_DropZoneFileUpload
      {...getRootProps({ isDragActive, refKey: "innerRef" })}
    >
      <input {...getInputProps()} accept=".xlsx" />
      <div className="dropzone_content">
        <img src={uploadCloudIcon} className="img" />
        <div className="description">Drop your file here</div>
        <div className="sub_description">or</div>
        <RotaButton className="browse_btn" onClick={open}>
          Browse
        </RotaButton>
      </div>
    </Styled_DropZoneFileUpload>
  );
};

export default DropZoneFileUpload;
